import {
  buildSearchBox,
  buildResultList,
  buildResultsPerPage,
  buildPager,
  buildBreadcrumbManager,
  buildQuerySummary,
  buildDateFilter,
  buildDidYouMean,
  buildSort
} from '@coveo/headless';
import { headlessEngine } from '../engine';

const { dataset } =
  document.getElementsByClassName('coveo-search-results__main-wrapper')[0] ||
  document.getElementsByClassName('coveo-search-results__global-search-box')[0];

export const maxResultsPerPage = dataset.resultsPerPage
  ? JSON.parse(dataset.resultsPerPage)
  : 10;
export const fieldsToInclude = dataset.searchFields
  ? JSON.parse(dataset.searchFields)
  : '';

/*
  Usage:
  import * as Controllers from  '../../coveo/controllers/controllers';

  Then, in the component:
*/

export const searchBox = buildSearchBox(headlessEngine, {
  options: {
    highlightOptions: {
      notMatchDelimiters: {
        open: '<strong>',
        close: '</strong>'
      },
      correctionDelimiters: {
        open: '<i>',
        close: '</i>'
      }
    }
  }
});

export const resultList = buildResultList(headlessEngine, {
  options: {
    fieldsToInclude
  }
});

export const sortController = buildSort(headlessEngine, {});

export const facetBreadcrumb = buildBreadcrumbManager(headlessEngine);

export const resultsPerPage = buildResultsPerPage(headlessEngine, {
  initialState: { numberOfResults: maxResultsPerPage }
});

/*
  Usage:
 <DateFilter controller={Controllers.dateFilter} />
*/
export const dateFilter = buildDateFilter(headlessEngine, {
  options: {
    field: 'date'
  }
});

export const querySummary = buildQuerySummary(headlessEngine);

export const pager = buildPager(headlessEngine, {
  options: { numberOfPages: 3 }
});

export const didYouMean = buildDidYouMean(headlessEngine);
